import { render, staticRenderFns } from "./I18nInput.vue?vue&type=template&id=c8af03ca&scoped=true&"
import script from "./I18nInput.vue?vue&type=script&lang=js&"
export * from "./I18nInput.vue?vue&type=script&lang=js&"
import style0 from "./I18nInput.vue?vue&type=style&index=0&id=c8af03ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8af03ca",
  null
  
)

export default component.exports